/**
 * Shared in-memory cache for auth-config
 * Prevents multiple simultaneous components from sending duplicate requests to /api/auth-config
 */

let cachedAuthConfig = null;
let inFlightAuthConfigPromise = null;

export async function getAuthConfig(forceRefresh = false) {
    if (cachedAuthConfig && !forceRefresh) {
        return cachedAuthConfig;
    }
    if (inFlightAuthConfigPromise && !forceRefresh) {
        return inFlightAuthConfigPromise;
    }

    inFlightAuthConfigPromise = fetch('/api/auth-config')
        .then(async (res) => {
            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            cachedAuthConfig = data;
            inFlightAuthConfigPromise = null;
            return data;
        })
        .catch((err) => {
            inFlightAuthConfigPromise = null;
            throw err;
        });

    return inFlightAuthConfigPromise;
}

export function clearAuthConfigCache() {
    cachedAuthConfig = null;
    inFlightAuthConfigPromise = null;
}
